<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    class="d-flex align-center justify-center"
    style="width: 100%;height: calc(100vh - 100px)"
  >
    <div
      class="text-center"
      style="max-width: 300px"
    >
      <v-icon :size="48">
        mdi-access-point-network-off
      </v-icon>
      <div class="text-h4 mt-6">
        {{ $t('NetworkError') }}
      </div>
      <div class="text-body-1 mt-2 text--secondary">
        {{ $t('NetworkErrorHint') }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ErrorPage',
  mounted () {

  },
  methods: {}
}
</script>
